// AstriaMexicoThemeContext.tsx
import React, { createContext, useContext } from "react";
import { useMexicoTheme, MXPalette } from "./astriaMexicoTheme";

// Single source of truth for the Mexico lane's light/dark toggle — the shell
// owns the toggle button, every tab/card reads the resolved palette from
// here so the whole dashboard switches together instead of each component
// tracking (and possibly disagreeing on) theme state independently.

interface MXThemeContextValue {
  theme: "light" | "dark";
  colors: MXPalette;
  toggleTheme: () => void;
}

const MXThemeContext = createContext<MXThemeContextValue | undefined>(undefined);

export const AstriaMexicoThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const value = useMexicoTheme();
  return <MXThemeContext.Provider value={value}>{children}</MXThemeContext.Provider>;
};

export function useMexicoColors(): MXThemeContextValue {
  const ctx = useContext(MXThemeContext);
  if (!ctx) {
    throw new Error("useMexicoColors must be used within an AstriaMexicoThemeProvider");
  }
  return ctx;
}
